var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[(_vm.loading)?_c('div',{staticClass:"loading-overlay"},[(!_vm.getLoaderLogoPath)?_c('div',{staticClass:"spinner"}):_c('img',{staticClass:"loading-logo blinking",attrs:{"src":_vm.getLoaderLogoPath,"alt":"Loading..."}})]):_c('div',{ref:"mapContainer",staticClass:"google-map"})])
}
var staticRenderFns = []

export { render, staticRenderFns }